import React from 'react'
import { Drawer } from 'antd'
import { useDispatch } from 'react-redux'
import { conceptualLabelActions } from '../../../../../store/slices/conceptual-label.slice'
import CreateConceptualLabelForm from './CreateConceptualLabelForm'
import { useAutoFocusFirstInput } from '../../../../../../hooks/useAutoFocusFirstInput'

const CreateConceptualLabelDrawer = () => {
    const dispatch = useDispatch()

    const handleClose = () => dispatch(conceptualLabelActions.setShowCreateConceptualLabelDrawer(false))

    useAutoFocusFirstInput()
    
    return (
        <Drawer title='Create Conceptual Label' autoFocus onClose={handleClose} open width={560} destroyOnClose>
            <CreateConceptualLabelForm onSuccess={handleClose} />
        </Drawer>
    )
}

export default CreateConceptualLabelDrawer
